import { createSelector } from 'reselect'
import { EditionType } from '@graphics/gfx-common/dist/constants'
import { PackType, IEditionMetadata, GroupedEditionsType } from '../types/pack'
import { AppStateType } from '../reducers'
import { groupEditions } from '../services/editionsHelpers'
import { checkIfEditionIsDeleted } from '../services/pack'
import { matchId } from '../services/common'

export const selectPack = createSelector(
  [(state: AppStateType) => state.pack],
  (pack: PackType) => pack
)

export const selectPackId = createSelector(selectPack, ({ id }: PackType) => id)

export const selectParentGroup = createSelector(
  selectPack,
  ({ group }: PackType): string => group
)

export const selectEditions = createSelector(
  selectPack,
  ({ editions }: PackType): IEditionMetadata[] => editions || []
)

export const selectGroupedEditions = createSelector(
  selectEditions,
  (editions: IEditionMetadata[]): GroupedEditionsType => groupEditions(editions)
)

export const selectEdition = (editionId: string) =>
  createSelector(selectEditions, (editions: IEditionMetadata[]):
    | IEditionMetadata
    | undefined => editions.find(matchId(editionId)))

export const mapEditionToProps = (state, ownProps) => ({
  edition: selectEdition(ownProps.editionId)(state),
})

export interface IArchiveItem {
  label: string
  id: string
  value: boolean
}

export const selectRelatedEditions = (fileName?: string) =>
  createSelector(
    selectEditions,
    (editions: IEditionMetadata[]): IArchiveItem[] =>
      fileName
        ? editions
            .filter(
              ({ editionType }) => editionType === EditionType.GraphicFolder
            )
            .filter(({ file }) => file.fileName === fileName)
            .map((edition) => ({
              label: edition.editionName,
              id: edition.id,
              value: false,
            }))
        : []
  )

export const selectIsDeletedFilePresentInEditions = createSelector(
  selectPack,
  ({ editions }: PackType) => editions.some(checkIfEditionIsDeleted)
)
